import { Task } from "./ParallelTask";

export class SequentialTask<T> {
    private tasks: Task<T>[];
    private controller: AbortController;

    constructor(tasks: Task<T>[]) {
        this.tasks = tasks;
        this.controller = new AbortController();
    }

    public cancel(reason?: string): void {
        this.controller.abort(reason || "Sequence stopped");
    }

    public async execute(options = { wait: true }): Promise<T[] | string | void> {
        const { signal } = this.controller;

        const executionPromise = (async () => {
            const results: T[] = [];
            try {
                for (const [, task] of this.tasks.entries()) {
                    if (signal.aborted) throw new Error(signal.reason);
                    results.push(await Promise.resolve(task(signal)));
                }
                return results;
            } catch (err: any) {
                console.log(`[SequentialTask] Sequence cancelled: ${err.message}`);
                return "CANCELLED";
            }
        })();

        if (options.wait) return await executionPromise;
        executionPromise.catch(() => { });
    }
}
